import MaterialButton from '@material-ui/core/Button'
import cn from 'classnames'

const Button = props => {
  const { className, size, type, variant, ...rest } = props

  return (
    <MaterialButton
      size={size}
      color={type}
      className={cn(className, `custom-btn-${type}`)}
      variant={variant}
      {...rest}
    />
  )
}

Button.defaultProps = {
  type: 'default',
  size: 'medium',
  variant: 'contained',
}

export default Button
